import { HttpClient, HttpEvent, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from "@angular/core";
import { firstValueFrom, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ItemMin } from '../entites/item-min';
import { Router } from '@angular/router';
import { ReponseBase } from './reponse-base';
import { Item } from '../entites/item';
import { Inventaire } from '../entites/inventaire';
import { HistoriqueItem } from '../entites/historiqueItem';
import { NoteEntite } from '../entites/note';
import { ValeurAttribut } from '../entites/valeur-attribut';
import { AnalyseItem } from '../entites/analyse-item';
import { RequeteRetourReparation } from './requetes/requete-retour-reparation';
import { RequeteAjusterInventaireItem } from './requetes/requete-ajuster-inventaire-item';
import { RequeteCreerPiece } from './requetes/requete-creer-piece';
import { CacheMap, SignalWithWatcher } from './base.service';
import { BaseService } from './base.service';
import { MessageService, ConfirmationService, MenuItem } from 'primeng/api';
import { HubConnection } from '@microsoft/signalr';
import { SihcHubService, SihcEvents } from './sihc-hub.service';
import { RequeteChangerEmplacementDepart } from './requetes/requete-changer-emplacement-depart';
import { DialogService } from 'primeng/dynamicdialog';
import { ProfilService } from './profil-service';
import { DonneesBaseService } from './donnees-base-service';
import { EStatuts } from '../entites/enums/statuts';
import { ReparationService } from './reparation-service';
import { RequisitionService } from './requisition-service';
import { EmpruntService } from './emprunt.service';
import { GarantieService } from './garantie-service';
import { ETypesRequisition } from '../entites/enums/type-requisition';
import { Emplacement } from '../entites/emplacement';
import { RequisitionMin } from '../entites/requisition-min';
import { ReparationEntite } from '../entites/reparation';
import { ArchivageComponent, RetourArchivage } from '../controles/archivage.component';
import { SaisieNumeroComponent } from '../controles/saisie-numero.component';
import { SelectionItemSimpleComponent, ResultatSelectionItemSimple } from '../controles/selection-item-simple.component';
import { SelectionEmplacementComponent } from '../controles/selection-emplacement.component';
import { ReparationComponent } from '../controles/reparation.component';
import { RetourReparationComponent, ParametresRetourReparation } from '../controles/retour-reparation.component';
import { AjoutEmpruntsComponent } from '../pages/emprunts/ajout-emprunts.component';
import { SelectionRetourComponent } from '../controles/selection-retour.component';
import { CreationRetourComponent } from '../controles/creation-retour.component';
import { Emprunt } from '../entites/emprunt';
import { CreationPieceComponent, ResultatCreationPiece } from '../controles/mecanique/creation-piece.component';
import { CreationItemComponent } from '../controles/creation-item.component';
import { AjoutItemComponent } from '../pages/items/controles/ajout-item.component';
import { SupabaseService } from './supabase.service';

@Injectable({ providedIn: 'root', deps: [MessageService, Router, ConfirmationService, DialogService] })
export class ItemService extends BaseService {

  private obtenirListeUrl = environment.apiBaseUrl + 'item';
  private obtenirHeuresUrl = environment.apiBaseUrl + 'item/heures';
  private obtenirListeParStatutUrl = environment.apiBaseUrl + 'item/?statutId={statutId}';
  private obtenirDetailUrl = environment.apiBaseUrl + 'item/';
  private obtenirInventaireUrl = environment.apiBaseUrl + 'item/inventaire/';
  private obtenirHistoriqueUrl = environment.apiBaseUrl + 'item/historique/';
  private obtenirHistoriquePiecesUrl = environment.apiBaseUrl + 'item/historiquepieces/';
  private obtenirLiaisonsUrl = environment.apiBaseUrl + 'item/liaisons/';
  private obtenirNotesUrl = environment.apiBaseUrl + 'item/notes/';
  private obtenirAttributsUrl = environment.apiBaseUrl + 'item/attributs/';
  private modifierAttributsUrl = environment.apiBaseUrl + 'item/attributs/';
  private obtenirAnalyseUrl = environment.apiBaseUrl + 'item/{id}/analyse';
  private obtenirProchainUrl = environment.apiBaseUrl + 'item/prochainNumero';
  private archiverUrl = environment.apiBaseUrl + 'item/archiver';
  private verifierExisteUrl = environment.apiBaseUrl + 'item/existe/{numero}';
  private modifierNumeroUrl = environment.apiBaseUrl + 'item/modifiernumero';
  private fusionnerUrl = environment.apiBaseUrl + 'item/fusionner/{idSource}/{idCible}';
  private indiquerMecaniqueUrl = environment.apiBaseUrl + 'item/mecanique';
  private changerEmplacementDepartUrl = environment.apiBaseUrl + 'item/{id}/changerEmplacementDepart';
  private marquerPhotoPrincipaleUrl = environment.apiBaseUrl + 'item/{id}/photoprincipale/{documentId}';
  private retirerPhotoPrincipaleUrl = environment.apiBaseUrl + 'item/{id}/photoprincipale';

  private creerItemUrl = environment.apiBaseUrl + "item";
  private creerPieceUrl = environment.apiBaseUrl + "item/piece";
  private modifierItemUrl = environment.apiBaseUrl + "item/modifier";
  private modifierStatutItemUrl = environment.apiBaseUrl + "item/{itemId}/statut/modifier/{statutId}";
  private ajusterInventaireItemUrl = environment.apiBaseUrl + "item/ajusterInventaire";
  private retourReparationUrl = environment.apiBaseUrl + "item/retourReparation";

  private hubConnection: HubConnection;

  private itemsCache = new CacheMap<string, SignalWithWatcher<ItemMin[]>>(30);

  public httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  };

  constructor(
    private http: HttpClient,
    public router: Router,
    public messageService: MessageService,
    private dialogService: DialogService,
    private profilService: ProfilService,
    private sdb: DonneesBaseService,
    private confirmationService: ConfirmationService,
    private reparationService: ReparationService,
    private requisitionService: RequisitionService,
    private empruntService: EmpruntService,
    private garantieService: GarantieService,
    private itemsHub: SihcHubService,
    private supabaseService: SupabaseService
  ) {
    super(messageService, router);
    this.hubConnection = this.itemsHub.connection;
    void this.itemsHub.subscribe('items');

    if (!this.router.url.includes('/items') && this.supabaseService.isAuthenticated) {
      this.ObtenirItems(null, null, (data: ItemMin[]) => {
        return data.map(item => ({
          ...item,
          assignation: item.employe ? item.employe.prenom + ' ' + item.employe.nom : item.emplacement?.nom,
          ...item.valeursAttributs?.reduce((acc, val, index) => ({
            ...acc,
            ['att' + val.attribut.attributId]: val.valeur
          }), {}) || {}
        }));
      }).subscribe();
    }
  }

  public ObtenirItems(statutId: number, searchTerm?: string, transformFunction?: (data: ItemMin[]) => ItemMin[]): Observable<HttpEvent<SignalWithWatcher<ItemMin[]>>> {
    let params = new HttpParams();
    if (statutId) {
      params = params.set('statutId', statutId.toString());
    }
    if (searchTerm) {
      params = params.set('searchTerm', searchTerm);
    }
    return this.http.get<ItemMin[]>(this.obtenirListeUrl, { params, observe: 'events', reportProgress: true })
      .watchUpdatesAndEvents({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'itemId',
          events: { add: SihcEvents.itemsAdd, update: SihcEvents.itemsUpdate, delete: SihcEvents.itemsDelete }
        },
        caching: {
          key: `items-${statutId}`,
          cacheMap: this.itemsCache
        },
        transformFunction: transformFunction
      })
  }

  public ObtenirItemMin(statutId: number, transformFunction?: (data: ItemMin[]) => ItemMin[]): Observable<HttpEvent<SignalWithWatcher<ItemMin[]>>> {
    let params = new HttpParams();
    if (statutId) {
      params = params.set('statutId', statutId.toString());
    }
    return this.http.get<ItemMin[]>(this.obtenirListeUrl + "/min", { params, observe: 'events', reportProgress: true })
      .watchUpdatesAndEvents({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'itemId',
          events: { add: SihcEvents.itemsAdd, update: SihcEvents.itemsUpdate, delete: SihcEvents.itemsDelete }
        },
        caching: {
          key: `items-${statutId}`,
          cacheMap: this.itemsCache
        },
        transformFunction: transformFunction
      })
  }

  public ObtenirHeures(): Promise<ReponseBase<ItemMin[]>> {

    var p = this.http.get<ReponseBase<ItemMin[]>>(this.obtenirHeuresUrl)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }



  public ObtenirItem(id: number): Observable<SignalWithWatcher<Item>> {
    return this.http.get<Item>(this.obtenirDetailUrl + id.toString())
      .pipe(
        catchError(error => this.handleError(error))
      )
      .watchUpdates({
        hub: {
          hubConnection: this.hubConnection,
          idField: 'itemId',
          events: { add: SihcEvents.itemsAdd, update: SihcEvents.itemsUpdate, delete: SihcEvents.itemsDelete }
        }
      })
  }


  public ObtenirInventaireItem(id: number): Promise<ReponseBase<Inventaire[]>> {
    var p = this.http.get<ReponseBase<Inventaire[]>>(this.obtenirInventaireUrl + id.toString())
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirHistoriqueItem(id: number): Promise<ReponseBase<HistoriqueItem[]>> {
    var p = this.http.get<ReponseBase<HistoriqueItem[]>>(this.obtenirHistoriqueUrl + id.toString())
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirHistoriquePiecesItem(id: number): Promise<ReponseBase<HistoriqueItem[]>> {
    var p = this.http.get<ReponseBase<HistoriqueItem[]>>(this.obtenirHistoriquePiecesUrl + id.toString())
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirLiaisonsItem(id: number): Observable<ReponseBase<ItemMin[]>> {
    return this.http.get<ReponseBase<ItemMin[]>>(this.obtenirLiaisonsUrl + id.toString())
      .pipe(
        catchError(error => this.handleError(error))
      );
  }

  public ObtenirNotesItem(id: number): Promise<ReponseBase<NoteEntite[]>> {
    var p = this.http.get<ReponseBase<NoteEntite[]>>(this.obtenirNotesUrl + id.toString())
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirAttributsItem(id: number): Promise<ReponseBase<ValeurAttribut[]>> {
    var p = this.http.get<ReponseBase<ValeurAttribut[]>>(this.obtenirAttributsUrl + id.toString())
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierAttributsItem(id: number, valeurs: ValeurAttribut[]): Promise<ReponseBase<ValeurAttribut[]>> {
    var p = this.http.post<ReponseBase<ValeurAttribut[]>>(this.modifierAttributsUrl + id.toString(), JSON.stringify(valeurs), this.httpOptions)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }


  public ObtenirAnalyseItem(id: number): Promise<ReponseBase<AnalyseItem>> {
    var p = this.http.get<ReponseBase<AnalyseItem>>(this.obtenirAnalyseUrl.replace('{id}', id.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ObtenirProchainNumero(prefixe: string): Promise<ReponseBase<string>> {
    var p = this.http.post<ReponseBase<string>>(this.obtenirProchainUrl, JSON.stringify(prefixe), this.httpOptions)
      .pipe(
        catchError(error => this.handleError(error))
      ).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public CreerItem(item: Item): Promise<ReponseBase<Item>> {
    var p = this.http.post<ReponseBase<Item>>(this.creerItemUrl, JSON.stringify(item), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public CreerPiece(requete: RequeteCreerPiece): Promise<ReponseBase<Item>> {
    var p = this.http.post<ReponseBase<Item>>(this.creerPieceUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierItem(item: Item): Promise<ReponseBase<Item>> {
    var p = this.http.post<ReponseBase<Item>>(this.modifierItemUrl, JSON.stringify(item), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierStatut(itemId: number, statutId: number): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.modifierStatutItemUrl.replace('{itemId}', itemId.toString()).replace('{statutId}', statutId.toString()), null, this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }


  public AjusterInventaire(requete: RequeteAjusterInventaireItem): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.ajusterInventaireItemUrl, JSON.stringify(requete), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public RetourReparation(req: RequeteRetourReparation): Promise<ReponseBase<number>> {
    var p = this.http.post<ReponseBase<number>>(this.retourReparationUrl, JSON.stringify(req), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public Archiver(item: Item): Promise<ReponseBase<Item>> {
    var p = this.http.post<ReponseBase<Item>>(this.archiverUrl, JSON.stringify(item), this.httpOptions)
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public VerifierExiste(numero: string): Promise<ReponseBase<number>> {
    var p = this.http.get<ReponseBase<number>>(this.verifierExisteUrl.replace('{numero}', numero.toString()))
      .toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ModifierNumero(item: Item): Promise<ReponseBase<Item>> {
    var p = this.http.post<ReponseBase<Item>>(this.modifierNumeroUrl, JSON.stringify(item), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public Fusionner(idSource: number, idCible: number): Promise<ReponseBase<boolean>> {
    var p = this.http.post<ReponseBase<boolean>>(this.fusionnerUrl.replace('{idSource}', idSource.toString()).replace('{idCible}', idCible.toString()), null, this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public ChangerEmplacementDepart(id: number, requete: RequeteChangerEmplacementDepart): Observable<void> {
    return this.http.post<ReponseBase<Item>>(this.changerEmplacementDepartUrl.replace('{id}', id.toString()), JSON.stringify(requete), this.httpOptions).pipe(
      catchError(error => this.handleError(error))
    );
  }

  public IndiquerMecanique(item: Item): Promise<ReponseBase<Item>> {
    var p = this.http.post<ReponseBase<Item>>(this.indiquerMecaniqueUrl, JSON.stringify(item), this.httpOptions).toPromise();

    p.catch(() => this.router.navigateByUrl('error'));

    return p;
  }

  public MarquerPhotoPrincipale(id: number, documentId: number): Observable<number> {
    return this.http.post<number>(this.marquerPhotoPrincipaleUrl.replace('{id}', id.toString()).replace('{documentId}', documentId.toString()), null, this.httpOptions);
  }

  public RetirerPhotoPrincipale(id: number): Observable<void> {
    return this.http.delete<void>(this.retirerPhotoPrincipaleUrl.replace('{id}', id.toString()), this.httpOptions);
  }

  public ItemVersItemMin(item: Item): ItemMin {
    return {
      itemId: item.itemId,
      numero: item.numero,
      description: item.description,
      categorie: item.categorie,
      sousCategorie: item.sousCategorie,
      marque: item.marque,
      modele: item.modele,
      noCtrl: item.noCtrl,
      unite: item.unite,
      indSuiviMecanique: item.indSuiviMecanique,
      indSuiviHeures: item.indSuiviHeures,
      indSuiviKms: item.indSuiviKms,
      emplacement: item.emplacement,
      employe: item.employe,
      localisation: item.localisation,
      valeursAttributs: item.valeursAttributs,
      heuresCompteur: item.heuresCompteur,
      heuresReelles: item.heuresReelles,
      dateHeures: item.dateHeures,
      kmCompteur: item.kmCompteur,
      kmReel: item.kmReel,
      dateKm: item.dateKm,
      departementMecanique: item.departementMecanique,
      estLie: item.estLie,
      photoId: item.photoId,
      statut: item.statut,
    };
  }

  public ObtenirAttributs(attributs: string): Observable<ValeurAttribut[]> {
    return this.http.get<ValeurAttribut[]>(this.obtenirAttributsUrl, { params: { attributs } }).pipe(
      catchError(error => this.handleError(error))
    );
  }

  // Helper method to check authorization
  private estAutorise(code: string): boolean {
    return this.profilService.estAutoriseTache(code);
  }

  /**
   * Get the list of action menu items for an item
   * @param item The item to generate actions for
   * @param attributs The item attributes (needed for marquerComplet validation)
   * @returns Array of MenuItem objects for the Actions menu
   */
  public getItemActions(item: Item, attributs?: ValeurAttribut[]): MenuItem[] {
    let items: MenuItem[] = [
      {
        label: 'Déplacer',
        icon: 'pi pi-fw pi-reply',
        visible: this.estAutorise('item_action_deplacer') && item.statut.statutId != EStatuts.Archive && item.categorie.estUnique,
        disabled: item.estLie,
        command: () => this.deplacer(item)
      },
      {
        label: 'Emprunter', icon: 'pi pi-fw pi-user',
        visible: item.statut.statutId != EStatuts.Archive && item.employe == null && this.estAutorise('emprunt'),
        command: () => this.emprunter(this.ItemVersItemMin(item))
      },
      {
        label: 'Retourner', icon: 'pi pi-fw pi-undo',
        visible: this.estAutorise('requisition_creer') && item.emplacement?.emplacementId != 10000 && item.statut.statutId != EStatuts.Archive,
        command: () => this.retourner(this.ItemVersItemMin(item))
      },
      {
        label: 'Changer emplacement de départ',
        icon: 'pi pi-fw pi-map-marker',
        visible: this.estAutorise('item_action_deplacer') && item.statut.statutId != EStatuts.Archive && item.categorie.estUnique && item.nbEntreesHistorique == 0,
        disabled: item.estLie || item.employe != null,
        command: () => this.changerEmplacementDepart(item)
      },
      {
        label: 'Envoyer en réparation',
        icon: 'pi pi-fw pi-minus-circle',
        visible: this.estAutorise('reparation_creer') && item.statut.statutId == EStatuts.Actif && item.categorie.estUnique,
        command: () => this.reparation(item)
      },
      {
        label: 'Retour de réparation',
        icon: 'pi pi-fw pi-minus-circle',
        visible: this.estAutorise('reparation_retour') && item.statut.statutId == EStatuts.EnReparation,
        command: () => this.retourReparation(item)
      },
      { separator: true },
      {
        label: 'Changer de numéro',
        icon: 'pi pi-fw pi-tag',
        visible: this.estAutorise('item_action_modifier_numero'),
        command: () => this.changerNumero(item)
      },
      {
        label: 'Fusionner',
        icon: 'pi pi-fw pi-share-alt',
        visible: this.estAutorise('item_action_modifier_numero') && (item.categorie.categorieId == 3 || item.categorie.categorieId == 6),
        command: () => this.fusionner(item)
      },
      {
        label: 'Dupliquer',
        icon: 'pi pi-fw pi-copy',
        visible: this.estAutorise('item_action_modifier_numero'),
        command: () => this.dupliquer(item)
      },
      { separator: true },
      {
        label: 'Réactiver',
        icon: 'pi pi-fw pi-undo',
        visible: this.estAutorise('item_action_archiver') && item.statut.statutId == EStatuts.Archive,
        command: () => this.reactiver(item)
      },
      {
        label: 'Marquer comme complet', icon: 'pi pi-fw pi-times',
        visible: this.estAutorise('item_action_marquer_complet') && item.statut.statutId == EStatuts.Incomplet,
        command: () => this.marquerComplet(item, attributs)
      },
      {
        label: 'Marquer comme incomplet', icon: 'pi pi-fw pi-minus-circle',
        visible: this.estAutorise('item_action_marquer_complet') && item.statut.statutId == EStatuts.Actif,
        command: () => this.marquerIncomplet(item)
      },
      {
        label: 'Archiver',
        icon: 'pi pi-fw pi-times',
        styleClass: 'menuSuppression',
        visible: this.estAutorise('item_action_archiver') && item.statut.statutId != EStatuts.Archive,
        command: () => this.archiver(item)
      }
    ];

    if (items.every(x => x.visible === false)) return null;
    return items;
  }

  /**
   * Mark an item as complete
   * @param item The item to mark as complete
   * @param attributs The item attributes to validate
   */
  private marquerComplet(item: Item, attributs?: ValeurAttribut[]): void {
    if (attributs) {
      var attributsManquants = attributs.filter(x => x.attribut.indObligatoire && !x.valeur);

      if (attributsManquants && attributsManquants.length > 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Certains attributs obligatoires sont manquants. Veuillez compléter les attributs obligatoire avant de marquer l\'item comme étant complet.'
        });
        return;
      }
    }

    this.ModifierStatut(item.itemId, EStatuts.Actif).then(res => {
      if (res) {
        item.statut = this.sdb.Statut(EStatuts.Actif);
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été complété.' });
      } else {
        res.messages.forEach(x => {
          this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
        });
      }
    });
  }

  /**
   * Mark an item as incomplete
   * @param item The item to mark as incomplete
   */
  private marquerIncomplet(item: Item): void {
    this.confirmationService.confirm({
      message: `Voulez-vous vraiment marquer l'item ${item.description} (${item.numero}) comme étant incomplet ?`,
      accept: () => {
        this.ModifierStatut(item.itemId, EStatuts.Incomplet).then(res => {
          if (res) {
            item.statut = this.sdb.Statut(EStatuts.Incomplet);
            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été marqué comme étant incomplet.' });
          } else {
            res.messages.forEach(x => {
              this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description, sticky: true });
            });
          }
        });
      }
    });
  }

  async dupliquer(item: Item, navigateTo: boolean = true): Promise<number | null> {
    if (item.categorie.categorieId == 6) {
      const ref = this.dialogService.open(CreationPieceComponent, {
        data: {
          description: item.description,
          marque: item.marque,
          modele: item.modele
        },
        header: 'Ajout d\'une pièce mécanique',
        width: '90%'
      });
      const res = await firstValueFrom(ref.onClose);
      if (res) {
        if (navigateTo) {
          this.router.navigate(['/item/' + res.item.itemId]);
        }
        return res.item.itemId;
      }
      return null;
    } else {
      var numero = item.numero.includes('-') ? item.numero.split('-')[0] + '-' : null;
      const nouvelItem: Item = {
        categorie: item.categorie,
        sousCategorie: item.sousCategorie,
        compagnie: item.compagnie,
        description: item.description,
        numero: numero,
        marque: item.marque,
        modele: item.modele,
        emplacement: this.sdb.Emplacement(10000), // TODO : Hard-code : 10000
        produitDangereux: item.produitDangereux
      };
      if (item.localisation) {
        nouvelItem.localisation = this.sdb.LocalisationEntrepot(item.localisation.localisationEntrepotEntiteId);
      }
      console.log(nouvelItem);
      const ref = this.dialogService.open(AjoutItemComponent, {
        data: {
          item: nouvelItem,
        },
        header: 'Duplication d\'un item',
        width: '60%'
      });
      const res = await firstValueFrom(ref.onClose);
      if (res) {
        if (navigateTo) {
          this.router.navigate(['/item/' + res.itemId]);
        }
        return res.itemId;
      }
      return null;
    }
  }

  /**
   * Borrow an item
   * @param item The item to borrow
   */
  private emprunter(item: ItemMin): void {
    this.dialogService.open(AjoutEmpruntsComponent, {
      data: {
        item: item,
        employe: this.profilService.ProfilCourant()
      },
      header: 'Emprunter',
      width: '60%'
    });
  }

  /**
   * Return an item
   * @param item The item to return
   */
  private async retourner(item: ItemMin): Promise<void> {
    var retours: RequisitionMin[] = [];

    if (item.employe != null) {
      this.retournerEmprunt(item);
      return;
    }

    if (item.emplacement) {
      var x = await this.requisitionService.ObtenirRetoursActifs();
      retours = x.valeur.filter(x => x.de.emplacementId == item.emplacement.emplacementId);
    }

    if (retours.length > 0) {
      const ref = this.dialogService.open(SelectionRetourComponent, {
        data: {
          retours: retours
        },
        header: 'Sélectionner le retour',
        width: '85%'
      });

      ref.onClose.subscribe((retour: RequisitionMin) => {
        if (retour) {
          this.dialogService.open(CreationRetourComponent, {
            data: {
              retour: retour,
              items: [item]
            },
            header: 'Retour',
            width: '85%'
          });
        }
      });
    } else {
      this.dialogService.open(CreationRetourComponent, {
        data: {
          items: [item]
        },
        header: 'Retour',
        width: '85%'
      });
    }
  }

  /**
   * Return a borrowed item
   * @param item The borrowed item to return
   */
  private retournerEmprunt(item: ItemMin): void {
    this.empruntService.getActiveEmpruntForItem(item.itemId).subscribe((emprunt: Emprunt) => {
      if (emprunt) {
        const confirmationAction = () => {
          this.confirmationService.confirm({
            message: `Êtes-vous sûr de vouloir effectuer un retour de cet emprunt à l'emplacement ${emprunt.emplacementRetour?.nom}?`,
            header: 'Confirmation de retour manuel',
            icon: 'pi pi-info-circle',
            accept: () => {
              this.router.navigate(['/emprunt/retour', emprunt.empruntId], {
                queryParams: {
                  EmplacementId: emprunt.emplacementRetourId
                }
              });
            }
          });
        };

        if (emprunt.emplacementRetour) {
          confirmationAction();
        } else {
          this.dialogService.open(SelectionEmplacementComponent, {
            header: 'Sélectionner un emplacement de retour',
            width: '50%',
            data: {
              selection: emprunt.emplacementDepart?.emplacementId
            }
          }).onClose.subscribe((result: Emplacement) => {
            if (result) {
              emprunt.emplacementRetour = result;
              emprunt.emplacementRetourId = result.emplacementId;
              confirmationAction();
            }
          });
        }
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Aucun emprunt actif trouvé pour cet item.'
        });
      }
    });
  }

  /**
   * Archive an item
   * @param item The item to archive
   */
  private archiver(item: Item): void {
    const ref = this.dialogService.open(ArchivageComponent, {
      data: {
        itemId: item.itemId
      },
      header: `Archivage de : ${item.description} (${item.numero})`,
      width: '60%'
    });

    ref.onClose.subscribe((res: RetourArchivage) => {
      if (res) {
        item.statut = this.sdb.Statut(EStatuts.Archive);
        item.raisonArchive = this.sdb.RaisonArchive(res.raisonArchiveId);
        item.commentaireArchive = res.commentaire;
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été archivé.' });
      }
    });
  }

  /**
   * Reactivate an archived item
   * @param item The item to reactivate
   */
  private reactiver(item: Item): void {
    this.confirmationService.confirm({
      message: `Voulez-vous vraiment réactiver l'item ${item.description} (${item.numero}) ?`,
      accept: () => {
        this.ModifierStatut(item.itemId, EStatuts.Actif).then(x => {
          item.statut = this.sdb.Statut(x.valeur);
          this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'L\'item a été réactivé.' });
        });
      }
    });
  }

  /**
   * Change item number
   * @param item The item to change number for
   */
  private changerNumero(item: Item): void {
    const ref = this.dialogService.open(SaisieNumeroComponent, {
      header: 'Changement de numéro',
      width: '60%'
    });

    ref.onClose.subscribe((res: string) => {
      if (res) {
        this.ModifierNumero({
          itemId: item.itemId,
          numero: res
        }).then(resModifNumero => {
          if (resModifNumero.estUnSucces) {
            item.numero = resModifNumero.valeur.numero;
            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Le numéro de l\'item a été changé.' });
          } else {
            resModifNumero.messages.forEach(x => {
              this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
            });
          }
        });
      }
    });
  }

  /**
   * Merge items
   * @param item The source item to merge from
   */
  private fusionner(item: Item): void {
    const ref = this.dialogService.open(SelectionItemSimpleComponent, {
      data: {
        choixCategorieDisponible: false,
      },
      header: 'Sélectionner l\'item cible',
      width: '60%'
    });

    ref.onClose.subscribe((res: ResultatSelectionItemSimple) => {
      if (res) {
        this.confirmationService.confirm({
          message: `Voulez-vous vraiment fusionner l'item '${item.numero}' vers l'item '${res.item.numero}' ? Cette action est irreversible.`,
          header: 'Confirmation',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Fusion en cours...' });
            this.Fusionner(item.itemId, res.item.itemId).then(resModifNumero => {
              if (resModifNumero.estUnSucces) {
                this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Fusion effectuée.' });
                this.router.navigateByUrl('/item/' + res.item.itemId);
              } else {
                resModifNumero.messages.forEach(x => {
                  this.messageService.add({ severity: 'error', summary: 'Erreur', detail: x.description });
                });
              }
            });
          }
        });
      }
    });
  }

  /**
   * Move item to different location
   * @param item The item to move
   */
  private deplacer(item: Item): void {
    if (item.employe) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erreur',
        detail: 'L\'item est assigné à un employé. Veuillez désassigner l\'item avant de le déplacer.'
      });
      return;
    }

    const ref = this.dialogService.open(SelectionEmplacementComponent, {
      header: 'Déplacement',
      width: '60%',
      data: {
        selection: item.emplacement.emplacementId != 10000 ? 10000 : null
      }
    });

    ref.onClose.subscribe((res: Emplacement) => {
      if (res) {
        if (item.emplacement.emplacementId == res.emplacementId) {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: 'L\'item est déjà à l\'emplacement sélectionné.'
          });
          return;
        }

        var type: ETypesRequisition = ETypesRequisition.Transfert;
        if (res.emplacementId == 10000) {
          type = ETypesRequisition.Retour;
        } else if (item.emplacement.emplacementId == 10000) {
          type = ETypesRequisition.Requisition;
        }

        this.requisitionService.CreerRequisition({
          date: new Date(),
          de: item.emplacement,
          a: res,
          demandeur: this.profilService.ProfilCourant(),
          type: { typeRequisitionId: type },
          statut: this.sdb.Statut(EStatuts.Actif),
          itemsRequisition: [{
            itemRequisitionId: 0,
            item: this.ItemVersItemMin(item),
            statut: this.sdb.Statut(EStatuts.Actif),
            employe: this.profilService.ProfilCourant(),
            demandeur: this.profilService.ProfilCourant(),
            quantite: 1
          }]
        }).then(x => {
          if (x.estUnSucces) {
            item.emplacement = res;
            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Item déplacé' });
          } else {
            x.messages.forEach(m => {
              this.messageService.add({ severity: 'error', summary: 'Erreur', detail: m.description });
            });
          }
        });
      }
    });
  }

  /**
   * Change item's starting location
   * @param item The item to change starting location for
   */
  private changerEmplacementDepart(item: Item): void {
    const ref = this.dialogService.open(SelectionEmplacementComponent, {
      header: 'Changement d\'emplacement de départ',
      width: '60%',
      data: {
        selection: item.emplacement.emplacementId
      }
    });

    ref.onClose.subscribe((res: Emplacement) => {
      if (res) {
        this.ChangerEmplacementDepart(item.itemId, { emplacementId: res.emplacementId }).subscribe({
          next: () => {
            this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Emplacement de départ changé.' });
          }
        });
      }
    });
  }

  /**
   * Send item for repair
   * @param item The item to send for repair
   */
  private reparation(item: Item): void {
    const ref = this.dialogService.open(ReparationComponent, {
      data: {
        itemId: item.itemId
      },
      header: 'Envoi en réparation',
      width: '60%'
    });

    ref.onClose.subscribe((res: ReparationEntite) => {
      if (res) {
        item.statut = this.sdb.Statut(EStatuts.EnReparation);
        this.messageService.add({ severity: 'success', summary: 'Succès', detail: 'Item envoyé en réparation.' });
      }
    });
  }

  /**
   * Return item from repair
   * @param item The item to return from repair
   */
  private retourReparation(item: Item): void {
    this.reparationService.ObtenirListeParItem(item.itemId).then(res => {
      if (res) {
        const reparationActive = res.valeur.find(x => x.statut.statutId != EStatuts.Complete);

        if (reparationActive) {
          const ref = this.dialogService.open(RetourReparationComponent, {
            data: {
              reparations: [
                {
                  reparationId: reparationActive.reparationId,
                  item: item
                }
              ]
            },
            header: 'Retour de réparation',
            width: '60%'
          });

          ref.onClose.subscribe((res: boolean) => {
            if (res) {
              item.statut = this.sdb.Statut(EStatuts.Actif);

              this.garantieService.ObtenirListeParItem(item.itemId).then(x => {
                item.garanties = x.valeur;
              });

              this.messageService.add({ severity: 'success', summary: 'Succès', detail: `Retour complété` });
            }
          });
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: 'Impossible d\'effectuer le retour de réparation pour l\'instant.'
          });
        }
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: 'Impossible d\'effectuer le retour de réparation pour l\'instant.'
        });
      }
    });
  }
}
